import checkboxEmpty from '../images/checkbox_empty.svg';
import checkboxFilled from '../images/checkbox_filled.svg';

interface ICheckboxProps {
  checked: boolean;
  style?: React.CSSProperties;
}

export const Checkbox = ({ checked, style = {} }: ICheckboxProps) => (
  <img src={checked ? checkboxFilled : checkboxEmpty} alt="Checkbox" style={style} />
);
